export function getStylesRef(refName: string) {
  return `___ref-${refName || ''}`;
}
